import experimentApi from '@experiment-management-shared/api/experimentApi';
import { AUTOGENERATED_CURVE_PANEL_NUMBER_LIMIT } from '@experiment-management-shared/constants';
import { QueryConfig } from '@shared/api';
import { sortBy } from 'lodash';
import { useQuery } from 'react-query';

const getCurveNamesForExperiments = async (
  experimentKeys: string[],
  signal?: AbortSignal
) => {
  if (experimentKeys.length === 0) {
    return [];
  }

  const response = await experimentApi.getCurveNamesForExperiments(
    experimentKeys,
    signal
  );

  return response?.data?.curveNames?.slice(
    0,
    AUTOGENERATED_CURVE_PANEL_NUMBER_LIMIT
  );
};

interface AutogenCurvesPanelsOpts {
  experimentKeys: string[];
}

export const useExperimentsCurveNames = (
  { experimentKeys }: AutogenCurvesPanelsOpts,
  config?: QueryConfig<string[]>
) => {
  const sortedExperimentKeys = sortBy(experimentKeys);

  return useQuery(
    ['experiments-curve-names', { experimentKeys: sortedExperimentKeys }],
    ({ signal }) => getCurveNamesForExperiments(experimentKeys, signal),
    config
  );
};
